import {useCallback, useRef, useState} from 'react';

export function useTimer(interval: number) {
    const timeoutRef = useRef<number>();
    const [isTimedOut, setIsTimedOut] = useState(false);

    const end = useCallback(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }

        setIsTimedOut(false);
    }, []);

    const start = useCallback(() => {
        end();
        // @ts-ignore
        timeoutRef.current = setTimeout(() => setIsTimedOut(true), interval);
    }, [end, interval]);

    return {
        start,
        end,
        isTimedOut,
    };
}
